import React from 'react';
import { connect } from 'react-redux';
import BroadcastForm from 'components/broadcast/Form';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import { createBroadcast, updateBroadcast } from 'actions/Broadcast';
import { BROADCAST_FORM } from 'constants/ModalTypes';
import { clearModal } from 'actions';
import { Modal, ModalBody } from 'reactstrap';

const BroadcastModal = (props) => {
  const {
    modalOpen,
    createBroadcast,
    updateBroadcast,
    clearModal,
    broadcast,
    event,
  } = props;

  const clearThisModal = clearModal.bind(null, BROADCAST_FORM);
  const isEditMode = !!broadcast;

  const handleSubmit = (broadcastFormData) => {
    if (isEditMode) {
      updateBroadcast(broadcast._id, broadcastFormData);
    } else {
      createBroadcast(broadcastFormData);
    }

    clearThisModal();
  };

  return (
    <Modal isOpen={modalOpen} toggle={clearThisModal}>
      <StyledModalHeader toggle={clearThisModal}>
        {isEditMode ? 'Edit studio' : 'Create studio'}
      </StyledModalHeader>
      <ModalBody>
        {modalOpen && (
          <BroadcastForm
            broadcast={broadcast}
            onSubmit={handleSubmit}
            onCancel={clearThisModal}
            event={event}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default connect(
  ({ modal, event }) => {
    const props = {
      modalOpen: modal && modal.type === BROADCAST_FORM,
    };

    if (props.modalOpen) {
      return { ...props, broadcast: modal.initialValue, event };
    }

    return props;
  },
  {
    clearModal,
    createBroadcast,
    updateBroadcast,
  },
)(BroadcastModal);
